import React, { Component, Fragment } from 'react';
import { Button, Grid, GridColumn, GridRow } from 'semantic-ui-react';
import { formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import _ from 'lodash';

import {
  BidGroupEnum,
  BidPriceEnum,
  CurrentBidPriceEnum,
  FilterEnum,
  ItemEnum,
  ItemMaintenanceEnum,
} from 'Common/FieldEnum';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { resetDirty } from 'State/dirtyTracking/actions';
import { caseInsensitiveFilter, numericSortMethod } from 'Common/GridHelper';
import { Filter, Main } from 'Containers';
import { SelectField } from 'Common/SemanticWrapper';
import { LoadingPage } from 'Components';
import { toastSuccess, errorToast } from 'Common/ToastHelper';
import {
  getAcctCategoryForCurrentSite,
  getBidGroupForCurrentSite,
  getItemGroupForCurrentSite,
  getStorageLocationForCurrentSite,
  getVendorForCurrentSite,
} from 'State/filters/actions';
import { makeOptionsData } from 'Common/FormHelper';
import { ITEM_MAINTENANCE_FORM } from 'Common/FormEnum';
import { printGrid } from 'Common/PrintGrid';
import { resetForm } from 'State/forms/actions';
import ReactTable from 'Common/ReactTableWrapper';
import { setYesNoDialogProps } from 'Components/dialogs/state/actions';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { GridEnum } from 'Common/Constants/Enumeration/GridEnum';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import {
  ReactTableWrapperColumnProperties,
  BRACKET_PRICING_PLACEHOLDER,
} from 'Common/Constants';
import { setTableStates } from 'Common/UserSettings/state/actions';
import { clearTableSavedState } from 'Common/FormHelper';
import { getTableStates } from 'Common/UserSettings/helpers/helper';
import {
  KitchenItemPrepareInHouseFilterEnum,
  dateSortMethod,
  getFilteredData,
} from 'Common/GridHelper';

import {
  clearItemGridData,
  deleteItem,
  getItems,
  clearItemMaintenanceErrors,
} from './state/itemMaintenance/actions';
import { clearError } from './state/addEditItem/actions';
import ItemMaintenanceForm from './components/ItemMaintenanceForm';
import { ActiveStatusEnum, basicURL } from './helpers';

import 'Styles/pages/inventory/itemmaintenance/index.less';

const filterItemsOptions = [
  {
    key: 0,
    value: CurrentBidPriceEnum.All,
    text: 'All',
  },
  {
    key: 1,
    value: CurrentBidPriceEnum.WithCurrentBidPrice,
    text: 'With Current Bid Price',
  },
  {
    key: 2,
    value: CurrentBidPriceEnum.WithoutCurrentBidPrice,
    text: 'Without Current Bid Price',
  },
];
const activeStatusOptions = [
  { value: ActiveStatusEnum.Active, label: 'Active' },
  { value: ActiveStatusEnum.Inactive, label: 'Inactive' },
];
const filterValues = {
  [ItemMaintenanceEnum.IsWithCurrentBidPrice]: 0,
  [FilterEnum.GroupId_Bid]: 0,
  [FilterEnum.GroupId_Item]: 0,
  [FilterEnum.GroupId_Cat]: 0,
  [FilterEnum.VendorId]: 0,
  [FilterEnum.GroupId_Location]: 0,
  [ItemMaintenanceEnum.PrepareInHouse]: false,
};

class ItemMaintenanceContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accordionActiveIndex: 0,
      openColumnsOptions: false,
      modalData: {},
      filtered: [],
      resetPageOnDataChange: true,
      columns: [
        {
          Header: 'Item Code',
          accessor: ItemEnum.ItemCode,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Description',
          accessor: ItemEnum.Description,
          width: 200,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Item Packaging',
          accessor: ItemEnum.ItemPackaging,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Price',
          id: 'Price',
          accessor: row => {
            if (row[ItemEnum.HasBracketPricing]) {
              return BRACKET_PRICING_PLACEHOLDER;
            }

            return row[ItemEnum.PrimaryPrice];
          },
          className: 'right-align',
          sortMethod: numericSortMethod,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Kitchen Item',
          accessor: ItemEnum.PrepareInHouse,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Distributor',
          accessor: ItemEnum.VendorName,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Item Group',
          accessor: ItemEnum.ItemGroup,
          ...ReactTableWrapperColumnProperties,
          show: false,
        },
        {
          Header: 'Alternate Item',
          accessor: ItemEnum.AlternateItemId,
          ...ReactTableWrapperColumnProperties,
          show: false,
        },
        {
          Header: 'Account Category',
          accessor: ItemEnum.AccountCategory,
          ...ReactTableWrapperColumnProperties,
          show: false,
        },
        {
          Header: 'Bid Group',
          accessor: ItemEnum.BidGroup,
          ...ReactTableWrapperColumnProperties,
          show: false,
        },
        {
          Header: 'Tax Group',
          accessor: ItemEnum.TaxGroup,
          ...ReactTableWrapperColumnProperties,
          show: false,
        },
        {
          Header: 'Distributor Item',
          accessor: ItemEnum.VendorItem,
          ...ReactTableWrapperColumnProperties,
          show: false,
        },
        {
          Header: 'Brand',
          accessor: ItemEnum.CurrentBrand,
          ...ReactTableWrapperColumnProperties,
          show: false,
        },
        {
          Header: 'UPC',
          accessor: ItemEnum.UPC,
          ...ReactTableWrapperColumnProperties,
          show: false,
        },
        {
          Header: 'GTIN',
          accessor: ItemEnum.GTINNumber,
          ...ReactTableWrapperColumnProperties,
          show: false,
        },
        {
          Header: 'Begin Date',
          accessor: ItemEnum.BeginDate,
          sortMethod: dateSortMethod,
          ...ReactTableWrapperColumnProperties,
          show: false,
        },
        {
          Header: 'End Date',
          accessor: ItemEnum.EndDate,
          sortMethod: dateSortMethod,
          ...ReactTableWrapperColumnProperties,
          show: false,
        },
        {
          Header: 'Servings Per Purchase Unit',
          accessor: ItemEnum.ServingsPerPurchasingUnit,
          ...ReactTableWrapperColumnProperties,
          show: false,
        },
        {
          Header: 'Menu Costing',
          accessor: ItemEnum.MenuCosting,
          ...ReactTableWrapperColumnProperties,
          show: false,
        },
        {
          Header: 'Order Preference',
          accessor: ItemEnum.OrderPreference,
          ...ReactTableWrapperColumnProperties,
          show: false,
        },
        {
          Header: 'Storage Location',
          accessor: ItemEnum.StorageLocation,
          ...ReactTableWrapperColumnProperties,
          show: false,
        },
        {
          Header: 'Minimum Par Level',
          accessor: ItemEnum.MinimumParLevel,
          ...ReactTableWrapperColumnProperties,
          show: false,
        },
        {
          Header: 'Maximum Par Level',
          accessor: ItemEnum.MaximumParLevel,
          ...ReactTableWrapperColumnProperties,
          show: false,
        },
        {
          Header: 'Truck Route',
          accessor: ItemEnum.TruckRoute,
          ...ReactTableWrapperColumnProperties,
          show: false,
        },
        {
          width: 50,
          sortable: false,
          Cell: gridProps => {
            return GridContextMenu({
              gridProps,
              options: this.menuOptions,
            });
          },
        },
      ],
    };
    this.reactTable = React.createRef();
  }

  componentDidUpdate(prevProps) {
    const {
      deleted,
      itemDeleteMessage,
      itemSubmitted,
      clearError,
      clearItemMaintenanceErrors,
    } = this.props;
    if (
      errorToast(this.props, prevProps, 'bidGroupDataError') ||
      errorToast(this.props, prevProps, 'itemGroupDataError') ||
      errorToast(this.props, prevProps, 'acctCategoryDataError') ||
      errorToast(this.props, prevProps, 'vendorDataError') ||
      errorToast(this.props, prevProps, 'storageLocationDataError') ||
      errorToast(this.props, prevProps, 'itemDeleteError') ||
      errorToast(this.props, prevProps, 'itemDetailsError') ||
      errorToast(this.props, prevProps, 'submitError')
    ) {
      clearError();
      clearItemMaintenanceErrors();
    } else if (itemSubmitted && !prevProps.itemSubmitted) {
      toastSuccess('Item has been saved');
      clearError();
      clearItemMaintenanceErrors();
    } else if (deleted && !prevProps.deleted) {
      toastSuccess(itemDeleteMessage);
      clearError();
      clearItemMaintenanceErrors();
    }
  }
  componentDidMount() {
    this.props.getBidGroupForCurrentSite(BidGroupEnum.UnassignedAndAll);
    this.props.getItemGroupForCurrentSite();
    this.props.getAcctCategoryForCurrentSite();
    this.props.getVendorForCurrentSite();
    this.props.getStorageLocationForCurrentSite();
    this.props.getItems();
  }

  resetScroll = () => this.props.scrollMainTo(0, 0);

  onDeleteClick = row => {
    this.props.setYesNoDialogProps({
      showDialog: true,
      title: 'Delete Item',
      question: ` Are you sure you want to delete the item: ${row.Description}?`,
      yesCallback: () => this.handleDialog(true),
      noCallback: () => this.handleDialog(false),
    });
    this.setState({ modalData: row });
  };

  onEditClick = row => {
    this.props.history.push(`/itemmaintenance/${row.Id}`);
  };
  onAssignStorageLocationClick = row => {
    this.props.history.push(`/itemmaintenance/storagelocation/${row.Id}`);
  };
  menuOptions = [
    {
      icon: 'pencil',
      text: 'View/Edit',
      handler: this.onEditClick,
    },
    {
      icon: 'pencil',
      text: 'Storage Location(s)',
      handler: this.onAssignStorageLocationClick,
    },
    {
      icon: 'trash',
      text: 'Delete',
      className: 'danger',
      handler: this.onDeleteClick,
      // disabledWhen: row => !row.CanDeleteItem,
    },
  ];
  onAddItemClick = () => {
    this.props.history.push('/itemmaintenance/0');
  };
  componentWillUnmount() {
    this.props.clearItemGridData();
    this.clearTableSavedState();
    toast.dismiss();
  }
  clearTableSavedState = () => {
    const { history, allTableStates, setTableStates } = this.props;
    clearTableSavedState(history, basicURL, allTableStates, setTableStates, [
      TableNamesEnum.ITEM_MAINTENANCE_TABLE,
      TableNamesEnum.UPDATE_BID_PRICE_DETAILS_TABLE,
      TableNamesEnum.FIFO_TABLE,
      TableNamesEnum.TRANSACTION_DETAIL_TABLE,
      TableNamesEnum.ITEM_DETAIL_TABLE,
    ]);
  };

  getRootUrl = () => {
    const { url } = this.props.match;
    return url.substring(0, url.lastIndexOf('/'));
  };

  clearFilters = () => {
    this.setState({
      filtered: [],
      resetPageOnDataChange: true,
    });
    this.completeReset();
  };
  completeReset = () => {
    this.props.resetForm(ITEM_MAINTENANCE_FORM);
  };
  handleChange = (e, values) => {
    this.setState({ resetPageOnDataChange: true });
  };
  handleDialog(result) {
    if (result) {
      this.handleDeleteSubmit(this.state.modalData);
    }
  }
  handleChangeAccordion = (e, titleProps) => {
    const { index } = titleProps;
    const { accordionActiveIndex } = this.state;
    let newIndex = accordionActiveIndex === index ? -1 : index;

    this.setState({
      accordionActiveIndex: newIndex,
    });
  };

  handleDeleteSubmit = item => {
    this.resetScroll();
    return this.props.deleteItem(item.Id).then(() => {
      this.props.getItems();
    });
  };

  printGrid = (e, gridData) => {
    const { sortedData } = this.reactTable.current.getResolvedState();
    if ((gridData.length && sortedData.length) || sortedData.length) {
      printGrid({
        printable: sortedData.length ? sortedData : gridData,
        properties: this.state.columns.filter(column => {
          return typeof column.Header === 'string';
        }),
        gridHeaderStyle:
          'border-bottom: 1px solid orange; text-align: left; margin-bottom: 3px; font-size: 16px;',
        gridStyle: 'padding-top: 6px;',
        header: 'Meals Plus Inventory - Item Maintenance',
      });
    }
  };
  onResetPageOnDataChange = () => {
    this.setState({ resetPageOnDataChange: false });
  };

  render() {
    const {
      fetching,
      fetchingDropdown,
      itemDetails,
      assignItemsBidGroupData,
      assignItemsItemGroupData,
      assignItemsAcctCategoryData,
      assignItemsVendorData,
      assignItemsStorageLocationData,
      gridPreferenceLoading,
      gridPreferenceSubmitting,
      activeStatusOptionsValue,
      groupId_Bid,
      groupId_Item,
      groupId_Cat,
      vendorId,
      groupId_Location,
      isWithCurrentBidPrice,
      prepareInHouse,
      initialValues,
    } = this.props;
    const bidGroupOptions = makeOptionsData(assignItemsBidGroupData);
    const itemGroupOptions = makeOptionsData(assignItemsItemGroupData);
    const acctCategoryOptions = makeOptionsData(assignItemsAcctCategoryData);
    const vendorData = makeOptionsData(assignItemsVendorData);
    const storageLocationData = makeOptionsData(assignItemsStorageLocationData);
    const fields = [
      {
        name: ItemMaintenanceEnum.IsWithCurrentBidPrice,
        component: SelectField,
        type: 'text',
        options: filterItemsOptions,
        label: 'BID PRICE',
        maxLength: 20,
      },
      {
        name: FilterEnum.GroupId_Bid,
        component: SelectField,
        type: 'text',
        options: bidGroupOptions,
        label: 'BID GROUP',
        maxLength: 20,
      },
      {
        name: FilterEnum.GroupId_Item,
        component: SelectField,
        type: 'text',
        options: itemGroupOptions,
        label: 'ITEM GROUP',
      },
      {
        name: FilterEnum.GroupId_Cat,
        component: SelectField,
        type: 'text',
        options: acctCategoryOptions,
        label: 'ACCT. CATEGORY',
      },
      {
        name: FilterEnum.VendorId,
        component: SelectField,
        type: 'text',
        options: vendorData,
        label: 'DISTRIBUTOR',
      },
      {
        name: FilterEnum.GroupId_Location,
        component: SelectField,
        type: 'text',
        options: storageLocationData,
        label: 'STORAGE LOCATION',
      },
    ];

    const gridFilterValues = {};
    //prepareInHouse contain boolean value ,so need to check with undefined
    const propFiltersValue = {
      [ItemMaintenanceEnum.IsWithCurrentBidPrice]: isWithCurrentBidPrice
        ? isWithCurrentBidPrice
        : initialValues[ItemMaintenanceEnum.IsWithCurrentBidPrice],
      [FilterEnum.GroupId_Bid]: groupId_Bid
        ? groupId_Bid
        : initialValues[FilterEnum.GroupId_Bid],
      [FilterEnum.GroupId_Item]: groupId_Item
        ? groupId_Item
        : initialValues[FilterEnum.GroupId_Item],
      [FilterEnum.GroupId_Cat]: groupId_Cat
        ? groupId_Cat
        : initialValues[FilterEnum.GroupId_Cat],
      [FilterEnum.VendorId]: vendorId
        ? vendorId
        : initialValues[FilterEnum.VendorId],
      [FilterEnum.GroupId_Location]: groupId_Location
        ? groupId_Location
        : initialValues[FilterEnum.GroupId_Location],

      [ItemMaintenanceEnum.ActiveStatus]: activeStatusOptionsValue
        ? activeStatusOptionsValue
        : initialValues[ItemMaintenanceEnum.ActiveStatus],
    };
    if (prepareInHouse) {
      propFiltersValue[ItemMaintenanceEnum.PrepareInHouse] = prepareInHouse
        ? KitchenItemPrepareInHouseFilterEnum.Yes
        : KitchenItemPrepareInHouseFilterEnum.No;
    }
    _.map(propFiltersValue, function(value, key, items) {
      if (items[key] !== 0) {
        gridFilterValues[key] = items[key];
      }
    });
    if (gridFilterValues[FilterEnum.GroupId_Bid] === BidPriceEnum.UNASSIGNED) {
      gridFilterValues[FilterEnum.GroupId_Bid] = null;
    }
    if (
      propFiltersValue[ItemMaintenanceEnum.IsWithCurrentBidPrice] !==
      CurrentBidPriceEnum.All
    ) {
      gridFilterValues[ItemMaintenanceEnum.IsWithCurrentBidPrice] =
        propFiltersValue[ItemMaintenanceEnum.IsWithCurrentBidPrice] ===
        CurrentBidPriceEnum.WithCurrentBidPrice;
    }
    let newData = [];
    const storageLocationFilterId = String(
      gridFilterValues[FilterEnum.GroupId_Location]
    );
    delete gridFilterValues[FilterEnum.GroupId_Location];
    if (+storageLocationFilterId) {
      newData = getFilteredData(gridFilterValues, itemDetails);
      newData = _.filter(newData, item => {
        if (Array.isArray(item[ItemMaintenanceEnum.StorageLocationIds])) {
          return item[ItemMaintenanceEnum.StorageLocationIds].includes(
            storageLocationFilterId
          );
        }
      });
    } else {
      newData = getFilteredData(gridFilterValues, itemDetails);
    }

    const pageSizeOptions = [5, 10, 20, 100];
    newData.length > 100 && pageSizeOptions.push(newData.length);
    return (
      <Fragment>
        {(fetchingDropdown || gridPreferenceLoading) && <LoadingPage />}
        <Fragment>
          <Filter title={'Items'}>
            <Grid>
              <GridRow>
                <GridColumn width="8" floated="right" textAlign="right">
                  <Button content="Add Item" onClick={this.onAddItemClick} />
                </GridColumn>
              </GridRow>
            </Grid>
          </Filter>
          <Main shouldNotUsePageWidth>
            <ItemMaintenanceForm
              fields={fields}
              handleChange={this.handleChange}
              filterValues={filterValues}
              initialValues={initialValues}
              clearFilters={this.clearFilters}
              activeStatusOptions={activeStatusOptions}
              handleChangeAccordion={this.handleChangeAccordion}
              accordionActiveIndex={this.state.accordionActiveIndex}
            />
            <Button
              style={{
                marginTop: 16,
              }}
              className={'clear-filters-button'}
              content="Print"
              onClick={e => {
                this.printGrid(e, newData);
              }}
            />

            <ReactTable
              minRows={0}
              loading={
                fetching || gridPreferenceLoading || gridPreferenceSubmitting
              }
              data={newData}
              menu={'hasCogs'}
              saveState={{ tableName: TableNamesEnum.ITEM_MAINTENANCE_TABLE }}
              resizable={true}
              className={'-striped -highlight grid--fixed-row-height'}
              defaultFilterMethod={caseInsensitiveFilter}
              noDataText={fetching ? '' : 'No items found'}
              columns={this.state.columns}
              draggableColumns={true}
              showHideColumn={true}
              reactTableRef={this.reactTable}
              pageSizeOptions={pageSizeOptions}
              resetPageOnDataChange={this.state.resetPageOnDataChange}
              onResetPageOnDataChange={this.onResetPageOnDataChange}
              gridName={GridEnum.INV_Item_View}
            />
          </Main>
        </Fragment>
      </Fragment>
    );
  }
}

const selector = formValueSelector(ITEM_MAINTENANCE_FORM);
const mapStateToProps = (state, ownProps) => {
  const { itemListing, addEditItem, settings } = state.ItemMaintenanceState;
  const { gridPreference, filters } = state.CommonState;
  ownProps.setPageLevelDirty(getIsDirty(ITEM_MAINTENANCE_FORM)(state));

  return {
    itemDetails: itemListing.itemDetails,
    deleted: itemListing.deleted,
    deleting: itemListing.deleting,
    itemDeleteError: itemListing.itemDeleteError,
    itemDeleteMessage: itemListing.itemDeleteMessage,
    fetching: itemListing.fetching,
    itemSubmitted: addEditItem.submitted,
    submitError: addEditItem.submitError,
    initialValues: {
      [ItemMaintenanceEnum.IsWithCurrentBidPrice]: 0,
      [FilterEnum.GroupId_Bid]: 0,
      [FilterEnum.GroupId_Item]: 0,
      [FilterEnum.GroupId_Cat]: 0,
      [FilterEnum.VendorId]: 0,
      [FilterEnum.GroupId_Location]: 0,
      [ItemMaintenanceEnum.PrepareInHouse]: false,
      [ItemMaintenanceEnum.ActiveStatus]: ActiveStatusEnum.Active,
    },
    groupId_Bid: selector(state, FilterEnum.GroupId_Bid),
    groupId_Item: selector(state, FilterEnum.GroupId_Item),
    groupId_Cat: selector(state, FilterEnum.GroupId_Cat),
    vendorId: selector(state, FilterEnum.VendorId),
    groupId_Location: selector(state, FilterEnum.GroupId_Location),
    isWithCurrentBidPrice: selector(
      state,
      ItemMaintenanceEnum.IsWithCurrentBidPrice
    ),
    prepareInHouse: selector(state, ItemMaintenanceEnum.PrepareInHouse),
    activeStatusOptionsValue: selector(state, ItemMaintenanceEnum.ActiveStatus),
    fetchingDropdown:
      filters.bidGroupDataLoading ||
      filters.itemGroupDataLoading ||
      filters.acctCategoryDataLoading ||
      filters.vendorDataLoading ||
      filters.storageLocationDataLoading,
    isSelectedTab: settings.isSelectedTab,
    isDirty: getIsDirty()(state),
    security: state.SecurityState,
    assignItemsBidGroupData: filters.bidGroupData,
    assignItemsItemGroupData: filters.itemGroupData,
    assignItemsAcctCategoryData: filters.acctCategoryData,
    assignItemsVendorData: filters.vendorData,
    assignItemsStorageLocationData: filters.storageLocationData,
    itemDetailsError: itemListing.itemDetailsError,
    gridPreferenceLoading: gridPreference.loading,
    gridPreferenceSubmitting: gridPreference.isSubmitting,
    bidGroupDataError: filters.bidGroupDataError,
    itemGroupDataError: filters.itemGroupDataError,
    acctCategoryDataError: filters.acctCategoryDataError,
    vendorDataError: filters.vendorDataError,
    storageLocationDataError: filters.storageLocationDataError,
    submitted: gridPreference.submitted,
    allTableStates: getTableStates(state),
  };
};

const mapDispatchToProps = {
  getItems,
  clearItemGridData,
  deleteItem,
  clearError,
  clearItemMaintenanceErrors,
  resetDirty,
  getBidGroupForCurrentSite,
  getItemGroupForCurrentSite,
  getAcctCategoryForCurrentSite,
  getVendorForCurrentSite,
  getStorageLocationForCurrentSite,
  resetForm,
  setTableStates,
  setYesNoDialogProps,
};

export const ItemMaintenance = connect(
  mapStateToProps,
  mapDispatchToProps
)(ItemMaintenanceContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/itemmaintenance/ItemMaintenance.js